import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ExerciseHistoryPage = lazy(() => import("./ExerciseHistoryPage"));

const ExerciseHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ExerciseHistoryPage />
    </Suspense>
  );
};

export default ExerciseHistoryPageLazy;
